module.exports = __webpack_public_path__ + "img/Yogurt-Nan-800x527.d167c91a.jpg";